export function convertNamedNodeMapToObject(atts) {
    const obj = {};
    for (const key of Object.keys(atts)) {
        obj[atts[key].name] = atts[key];
    }
    return obj;
}
//# sourceMappingURL=functions.js.map